import { render, staticRenderFns } from "./BaseFormGroupTextareaUpload.vue?vue&type=template&id=df5d5f5a&"
import script from "./BaseFormGroupTextareaUpload.vue?vue&type=script&lang=js&"
export * from "./BaseFormGroupTextareaUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports